import { render, staticRenderFns } from "./ContentDetalleGeneral.vue?vue&type=template&id=418ed0d6&"
import script from "./ContentDetalleGeneral.vue?vue&type=script&lang=js&"
export * from "./ContentDetalleGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports